import { type FC, type ReactNode } from 'react'

type FormLabelProps = {
  label: ReactNode
  isRequired?: boolean
}

const FormLabel: FC<FormLabelProps> = ({ label, isRequired }) => (
  <>
    {label}
    {isRequired && <span aria-hidden="true">*</span>}
  </>
)

export default FormLabel
